'use strict';

window.ngtk = window.ngtk || {};
ngtk.model = ngtk.model || {};
ngtk.controller = ngtk.controller || {};

if (typeof window.console === 'undefined') {
    window.console = angular.noop;
    console.log = angular.noop;
    console.info = angular.noop;
    console.warn = angular.noop;
    console.error = angular.noop;
    console.dir = angular.noop;
}

